import React from "react";
import { withRouter } from "react-router-dom";
import { useStateValue } from "../../context/store";
import { VALUES } from "../../utils/constants";
import { makeStyles, AppBar, Toolbar, Typography } from "@material-ui/core";
import NoteAddIcon from "@material-ui/icons/NoteAdd";
import Button from "@material-ui/core/Button";
import IconButton from "../../utils/form/IconButton";
import Grid from "@material-ui/core/Grid";
import { permissionsConstans } from "../../constansPermissions";

import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  appBar: {
    minHeight: 102,
    marginTop: 42,
    boxShadow: "10px 5px 5px transparent",
    backgroundColor: "#fff",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    alignContent: "center",
    justifyContent: "space-between",
    alignItems: "center",
  },
  appBarClose: {
    //backgroundColor: "#099F9F",
    backgroundColor: "#fff",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShiftClose: {
    marginLeft: VALUES.MENU.DRAWER_WIDTH,
    width: "3%",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  appBarShift: {
    marginLeft: VALUES.MENU.DRAWER_WIDTH,
    width: "100%",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  toolbar: {
    minHeight: 55,
    marginLeft: "3%",
    background: "#fff",
    marginTop: "46px",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    alignContent: "space-between",
    flexDirection: "row",
    width: "100%",
  },
  toolbarIconsContainer: {
    display: "flex",
    alignItems: "center",
    color: "white",
    paddingRight: "70px",
  },
  menuButton: {
    marginLeft: "-20px!important",
  },
  hide: {
    display: "none",
  },
  avatar: {
    marginLeft: ".6em",
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  icons: {
    color: "white",
  },
  linkNav: {
    marginLeft: "24px",
    color: "#f7f7f7",
    fontSize: "12px",
    textDecoration: "none",
  },
  submit: {
    marginLeft: "40%",
    background: "#4D8D9D",
    "&:hover": {
      background: "#4D8D9D",
    },
  },
  paddingRight: {
    paddingRight: "70px",
  },
  buttonSearch: {
    color: "#ffffff",
    background: "#7EBDCE",
    marginLeft: "8px",
    marginRight: "8px",
    "&:hover": { color: "white", background: "#099F9F" },
  },
}));

const SubHeader = ({ history }) => {
  const classes = useStyles();
  const [{ breadCrumb, isDisableBtnContract, isDisabledBtnExam }, dispatch] =
    useStateValue();

  const handleOpenModal = () => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Gestionar cláusulas",
      breadCrumbSubText: "Gestionar cláusulas",
      index: 10,
      open: !breadCrumb.open,
    });
  };

  const handleToggleCreate = () => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Tipos de Contratos",
      breadCrumbSubText: "Tipos de Contratos",
      index: 11,
      open: !breadCrumb.open,
    });
  };

  const handleSaveStartProcess = () => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Iniciar Proceso",
      breadCrumbSubText: "Iniciar Proceso",
      index: 12,
      isSaveStartProcess: true,
    });
  };

  const handleCancelStartProcess = () => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Iniciar Proceso",
      breadCrumbSubText: "Iniciar Proceso",
      index: 12,
      isCancelStartProcess: true,
    });
  };

  const handleSavePermission = () => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Tramitar Permisos",
      breadCrumbSubText: "Tramitar Permisos",
      index: 19,
      isSavePermission: false,
    });
  };

  const handleCancelPermission = () => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Tramitar Permisos",
      breadCrumbSubText: "Tramitar Permisos",
      index: 19,
      isCancelPermission: true,
    });
  };
  const handleToggleCreateRequisition = () => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Requisiciones",
      breadCrumbSubText: "Tramitar Requisiciones",
      index: 13,
      isCreateReqStartProcess: true,
    });
  };
  const validationPermissionCreate = () => {
    const state = JSON.parse(localStorage.getItem("state"));
    const module = state?.permissions.find((x) => x.code === "REQ");

    if (
      module?.functionalities?.some(
        (x) => x === permissionsConstans.REQ_CREAR
      ) &&
      breadCrumb?.index === 13
    ) {
      return (
        <IconButton
          onClick={handleToggleCreateRequisition}
          icon={NoteAddIcon}
          text="Crear"
          variant="contained"
        ></IconButton>
      );
    }
  };

  const permissionTypeContract = () => {
    const state = JSON.parse(localStorage.getItem("state"));
    const module = state?.permissions.find((x) => x.code === "FOR_TIP_CON");
    if (
      module?.functionalities?.some(
        (x) => x === permissionsConstans.FOR_TIP_CON_CREAR
      ) &&
      !breadCrumb?.open &&
      breadCrumb?.index === 11
    ) {
      return (
        <Button
          onClick={handleToggleCreate}
          variant="contained"
          className={classes.buttonSearch}
        >
          GENERAR
        </Button>
      );
    }
  };

  const permissionGenerateContract = () => {
    const state = JSON.parse(localStorage.getItem("state"));
    const module = state?.permissions.find((x) => x.code === "CON");

    if (
      module?.functionalities?.some(
        (x) => x === permissionsConstans.CON_CREAR
      ) &&
      breadCrumb?.pathContarct
    ) {
      return (
        <Button
          onClick={() => history.push(`${breadCrumb?.pathContarct}`)}
          variant="contained"
          className={classes.buttonSearch}
        >
          GENERAR CONTRATO
        </Button>
      );
    }
  };

  const gotoLoginBtn = () => {
    const token_app = window.localStorage.getItem("token_app");
    if (!token_app) {
      window.location.assign("/auth/login");
    } else {
      window.location.assign("/dashboard/home");
    }
  };

  const handleCancelCv = () => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Hoja de vida",
      breadCrumbSubText: "Hoja de vida",
      index: 9,
      handleCancelCv: true,
    });
  };

  const handleCreateCv = () => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Hoja de vida",
      breadCrumbSubText: "Hoja de vida",
      index: 9,
      handleCreateCv: true,
    });
  };

  const handleEditCv = () => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Hoja de vida",
      breadCrumbSubText: "Hoja de vida",
      index: 9,
      handleEditCv: true,
    });
  };

  const handleCancelUserConfig = () => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Configuración de la cuenta",
      breadCrumbSubText: "Configuración de la cuenta",
      index: 15,
      handleCancelUserConfig: true,
    });
  };

  const handleSaveUserConfig = () => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Configuración de la cuenta",
      breadCrumbSubText: "Configuración de la cuenta",
      index: 15,
      handleSaveUserConfig: true,
    });
  };

  const handleSaveOrderClauses = () => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Configurar Formato de contrato",
      breadCrumbSubText: "Configurar Formato de contrato",
      index: 16,
      handleSaveOrderClauses: true,
    });
  };

  const handleOpenCreateForm = () => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Laboratorio",
      breadCrumbSubText: "Laboratorio",
      index: 22,
      handleOpenForm: true,
    });
  };

  const handleCreatePermissionForm = () => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Permisos",
      breadCrumbSubText: "Tramitar permiso de empleado",
      index: 19,
      handleCreatePermission: true,
    });
  };

  const showCreateCvButtons = () => {
    if (breadCrumb?.index === 9 && breadCrumb?.isCreateCv) {
      return (
        <>
          <Button
            onClick={handleCancelCv}
            variant="contained"
            className={classes.buttonSearch}
          >
            CANCELAR
          </Button>
          &nbsp;&nbsp;
          <Button
            onClick={handleCreateCv}
            variant="contained"
            className={classes.buttonSearch}
          >
            GUARDAR
          </Button>
        </>
      );
    }
  };

  const showEditCvButtons = () => {
    if (breadCrumb?.index === 9 && breadCrumb?.isEditCv) {
      return (
        <>
          <Button
            variant="contained"
            className={classes.buttonSearch}
            onClick={handleCancelCv}
          >
            CANCELAR
          </Button>
          &nbsp;&nbsp;
          <Button
            variant="contained"
            className={classes.buttonSearch}
            onClick={handleEditCv}
          >
            FINALIZAR
          </Button>
        </>
      );
    }
  };

  const showUserConfigurationButtons = () => {
    if (breadCrumb?.index === 15 && breadCrumb?.isUserConfig) {
      return (
        <>
          <Button
            onClick={handleCancelUserConfig}
            variant="contained"
            className={classes.buttonSearch}
          >
            CANCELAR
          </Button>
          &nbsp;&nbsp;
          <Button
            onClick={handleSaveUserConfig}
            variant="contained"
            className={classes.buttonSearch}
          >
            GUARDAR
          </Button>
        </>
      );
    }
  };

  const showReturnButtons = () => {
    const validIndexes = [
      101, 13, 14, 2, 3, 39, 5, 7, 18, 8, 10, 11, 17, 27, 28, 21, 22, 23, 24,
      25, 29, 30, 31, 32, 40, 41, 42, 51,
    ];
    if (validIndexes.includes(breadCrumb?.index)) {
      return (
        <Button
          onClick={() => {
            history.goBack();
          }}
          variant="contained"
          className={classes.buttonSearch}
        >
          VOLVER
        </Button>
      );
    }
  };

  const showLaboratoryButton = () => {
    const state = JSON.parse(localStorage.getItem("state"));
    const module = state?.permissions.find((x) => x.code === "LAB");

    if (
      module?.functionalities?.some(
        (x) => x === permissionsConstans.LAB_CREAR
      ) &&
      breadCrumb?.index === 22
    ) {
      return (
        <Button
          onClick={handleOpenCreateForm}
          variant="contained"
          className={classes.buttonSearch}
        >
          CREAR
        </Button>
      );
    }
  };

  const showCreatePermissionButtons = () => {
    if (breadCrumb?.index === 27) {
      return (
        <Button
          onClick={handleCreatePermissionForm}
          variant="contained"
          className={classes.buttonSearch}
        >
          CREAR
        </Button>
      );
    }
  };

  const showPermissionButtons = () => {
    if (breadCrumb?.index === 19) {
      return (
        <>
          <Button
            onClick={() =>
              history.push(
                "/dashboard/permissionsSearch/c3ee84b698ab7c8b1c8161180fc644c3cad1cd9b"
              )
            }
            variant="contained"
            className={classes.buttonSearch}
          >
            CANCELAR
          </Button>
          &nbsp;&nbsp;
          <Button
            type="submit"
            onClick={handleSavePermission}
            form="generatePermission"
            variant="contained"
            className={classes.buttonSearch}
          >
            GUARDAR
          </Button>
        </>
      );
    }
  };

  const handleOpenModalCollectiveService = () => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Consultar orden de servicio colectivo",
      breadCrumbSubText: "Consultar orden de servicio colectivo",
      index: 25,
      open: !breadCrumb.open,
    });
  };

  const showCreateMedicalExam = () => {
    const state = JSON.parse(localStorage.getItem("state"));
    const module = state?.permissions.find((x) => x.code === "EXAM_MED");
    if (
      module?.functionalities.some(
        (item) => item === permissionsConstans.EXAM_MED_CREAR
      ) &&
      breadCrumb?.index === 23
    ) {
      return (
        <Button
          onClick={() => history.push("/dashboard/medicalExams/create")}
          variant="contained"
          className={classes.buttonSearch}
        >
          Generar
        </Button>
      );
    }
  };

  const showCreateCollectiveService = () => {
    const state = JSON.parse(localStorage.getItem("state"));
    const module = state?.permissions.find((x) => x.code === "SER_COL");
    if (
      module?.functionalities.some(
        (item) => item === permissionsConstans.SER_COL_CREAR
      ) &&
      breadCrumb?.index === 25
    ) {
      return (
        <Button
          onClick={handleOpenModalCollectiveService}
          variant="contained"
          className={classes.buttonSearch}
        >
          Generar
        </Button>
      );
    }
  };

  const showGenerateEndowmentDelivery = () => {
    const state = JSON.parse(localStorage.getItem("state"));
    const module = state?.permissions.find((x) => x.code === "DOT");
    if (
      module?.functionalities.some(
        (item) => item === permissionsConstans.DOT_CREAR
      ) &&
      breadCrumb?.index === 31
    ) {
      return (
        <Button
          onClick={() => history.push("/dashboard/endowment-delivery/create")}
          variant="contained"
          className={classes.buttonSearch}
        >
          Generar
        </Button>
      );
    }
  };

  const showGeneratePregnant = () => {
    const state = JSON.parse(localStorage.getItem("state"));
    const module = state?.permissions.find((x) => x.code === "MAT_LIC");
    if (
      module?.functionalities.some(
        (item) => item === permissionsConstans.MAT_LIC_CREAR
      ) &&
      breadCrumb?.index === 30
    ) {
      return (
        <Button
          onClick={() => history.push("/dashboard/pregnant-record")}
          variant="contained"
          className={classes.buttonSearch}
        >
          Generar
        </Button>
      );
    }
  };

  const showGenerateRefund = () => {
    const state = JSON.parse(localStorage.getItem("state"));
    const module = state?.permissions.find((x) => x.code === "REF_REC");
    if (
      module?.functionalities.some(
        (item) => item === permissionsConstans.REF_REC_CREAR
      ) &&
      breadCrumb?.index === 41
    ) {
      return (
        <Button
          onClick={() => history.push("/dashboard/refund-recomendation-record")}
          variant="contained"
          className={classes.buttonSearch}
        >
          Generar
        </Button>
      );
    }
  };

  const newText = breadCrumb?.breadCrumbText?.indexOf("|") + 1;
  return (
    <AppBar id="SubheaderComponent" className={clsx(classes.appBar)}>
      <Toolbar id="toolbarComponent" className={classes.toolbar}>
        <Grid container>
          <Grid item xs={6}>
            <Typography style={{ fontSize: "20px", color: "#7EBDCE" }}>
              {breadCrumb?.breadCrumbText.substring(newText)}
            </Typography>
          </Grid>
          <Grid item xs={6} style={{ textAlign: "right", paddingRight: 45 }}>
            {breadCrumb?.path && (
              <IconButton
                onClick={() => history.push(`${breadCrumb?.path}`)}
                icon={NoteAddIcon}
                text="Crear"
                variant="contained"
                style={{ backgroundColor: "#7EBDCE", color: "#fff" }}
              ></IconButton>
            )}
            {breadCrumb?.subPath &&
              breadCrumb?.subPath !== "EDIT_CV" &&
              breadCrumb?.subPath !== "/dashboard/user" &&
              breadCrumb?.subPath !== "CREATE_CV" && (
                <Button
                  onClick={() => history.push(`${breadCrumb?.subPath}`)}
                  variant="contained"
                  className={classes.buttonSearch}
                >
                  Cancelar
                </Button>
              )}
            {breadCrumb?.isSubmit && (
              <Button
                type="submit"
                form="formUserInternal"
                variant="contained"
                className={classes.buttonSearch}
              >
                Guardar
              </Button>
            )}
            {breadCrumb?.submitContract && (
              <Button
                type="submit"
                form="generateContract"
                disabled={isDisableBtnContract.stateBtn}
                variant="contained"
                className={classes.buttonSearch}
              >
                Guardar
              </Button>
            )}

            {breadCrumb?.isSubmitOrderExam && (
              <>
                <Button
                  onClick={() => history.push("/dashboard/medicalExams")}
                  variant="contained"
                  className={classes.buttonSearch}
                >
                  CANCELAR
                </Button>
                <Button
                  type="submit"
                  form="createOrderExam"
                  disabled={isDisabledBtnExam.stateBtn}
                  variant="contained"
                  className={classes.buttonSearch}
                >
                  Guardar
                </Button>
              </>
            )}
            {breadCrumb?.isButtonCreate && (
              <Button
                onClick={handleOpenModal}
                variant="contained"
                className={classes.buttonSearch}
              >
                CREAR
              </Button>
            )}
            {!breadCrumb?.open && breadCrumb?.index === 16 && (
              <>
                <Button
                  onClick={() => history.push("/dashboard/type-contracts")}
                  variant="contained"
                  className={classes.buttonSearch}
                >
                  CANCELAR
                </Button>

                <Button
                  color="primary"
                  onClick={handleSaveOrderClauses}
                  variant="contained"
                  className={classes.buttonSearch}
                >
                  GUARDAR
                </Button>
              </>
            )}

            {!breadCrumb?.open && breadCrumb?.index === 12 && (
              <>
                <Button
                  onClick={handleCancelStartProcess}
                  variant="contained"
                  className={classes.buttonSearch}
                >
                  CANCELAR
                </Button>
                &nbsp;&nbsp;
                <Button
                  onClick={handleSaveStartProcess}
                  variant="contained"
                  className={classes.buttonSearch}
                >
                  GUARDAR
                </Button>
              </>
            )}

            {validationPermissionCreate()}
            {showCreateCvButtons()}
            {showEditCvButtons()}
            {showUserConfigurationButtons()}
            {permissionGenerateContract()}
            {/* {permissionTypeContract()} */}
            {showPermissionButtons()}
            {showCreatePermissionButtons()}
            {showLaboratoryButton()}
            {showCreateMedicalExam()}
            {showCreateCollectiveService()}
            {showGenerateEndowmentDelivery()}
            {showGeneratePregnant()}
            {showGenerateRefund()}

            {showReturnButtons()}
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export default withRouter(SubHeader);
